// extracted by mini-css-extract-plugin
module.exports = {"Container":"Abilities_Container__2tJfp"};